function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#212A33",
  fillRule: "evenodd",
  d: "M8 0a8 8 0 0 1 8 8A8 8 0 1 1 0 8a8 8 0 0 1 8-8m3.592 3C9.113 4.716 6.804 4.04 5.265 5.476c-.957.893-1.646 2.039-1.298 3.84l.153-.147c.757-.67 1.643-1.21 2.615-1.485a7 7 0 0 0 2.432-1.199 18 18 0 0 0 2.095-1.918 18 18 0 0 1-1.88 2.143C8.683 7.363 7.937 8.116 7 8.5s-1.667.695-2.348 1.447c-.68.763-1.26 1.593-1.652 2.646L4.332 13c.152-.653.473-1.341.866-1.971 1.57.865 3.274.24 4.302-.529 2.25-1.685 3.11-4.351 2.092-7.5"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/badges/ic-badge-leaf.svg";
export { SvgComponent as ReactComponent };